<div class="flex flex-col border-b bg-aux-gray-light">
  @if (isCloseMonthsProcessing()) {
    <aux-processing-loader class="mb-7 mt-7" [message]="closeMonthProcessingMessage" />
  }

  @if (isCloseSummaryVisible()) {
    <aux-period-close-header
      class="px-[24px] py-[21px]"
      [quarters]="quarterOptions()"
      [months]="monthsStat()"
      [selectedQuarter]="selectedQuarter"
    />
  }
</div>

@if (loading$ | async) {
  <div class="spinner m-auto my-40 h-32 w-32 border-8"></div>
} @else {
  <router-outlet />
}
